module.exports = __webpack_public_path__ + "img/fabrixapi-logo.41558ce8.png";